export default {
    init() {
        this.productActions();
        this.productCarrousel();
        this.galleryNavigation();
    },

    productActions(){
        let popUp = $('.archive-product-popup');

        $('.product-full-archive').on('click',function (e){
            e.preventDefault();
            popUp.fadeIn(300);
        });

        $('.archive-product-popup .close-pop').on('click', function (e) {
            e.preventDefault();
            popUp.fadeOut(300);
        });
    },

    productCarrousel(){
        let slickSettings = {
            slidesToShow: 1,
            dots: false,
            infinite: false,
            arrows: true,
            speed: 300,
            autoplay: false,
            slidesToScroll: 1,
            fade: true,
        };

        let slider = $('.product-full--gallery--main-slider');

        slider.slick(slickSettings);
        let selector = $('.product-full--gallery--main-slider .slick-slide a');

        selector.fancybox({
            loop: false,
            infobar: false,
            hash: false,
            backFocus: false,
            animationEffect: "fade",
            padding: 0,
            thumbs: {
                autoStart: false
            },
            buttons: [
                'slideShow',
                'fullScreen',
                'close'
            ]
        });
    },

    galleryNavigation() {
        let navItems = $('.product-full--gallery--navigation .item');
        let galleryItems = $('.product-full--gallery--main-slider .slick-slide');
        let fancyboxItems = $('.product-full--gallery--main-slider .slick-slide a');
        let slider = $('.product-full--gallery--main-slider');

        navItems.eq(0).addClass('active');

        // counter
        if (galleryItems.length > navItems.length) {
            $('.product-full--gallery--navigation .item.counter span').html( '+' + (galleryItems.length -11).toString());
        } else {
            $('.product-full--gallery--navigation .item.counter').remove();
        }

        // navigation click
        navItems.on('click', function () {
            let thisIndex = $(this).index();

            fancyboxItems.eq(thisIndex).trigger('click');
            navItems.removeClass('active');
            navItems.eq(thisIndex).addClass('active');
            slider.slick('slickGoTo', thisIndex);
        });

        // slider change
        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            navItems.removeClass('active');
            navItems.eq(nextSlide).addClass('active');

            if (nextSlide + 1 === 12) {
                fancyboxItems.eq(nextSlide).trigger('click');
            }
        });
    }
}